<template>
    <span role="checkbox"
          tabindex="0"
          aria-checked="false"
          class="group relative inline-flex items-center justify-center flex-shrink-0 h-5 w-10 cursor-pointer focus:outline-none"
          @click="$emit('toggle', ! on)"
    >
        <span aria-hidden="true"
              class="bg-gray-200 absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200"
              :class="{ 'bg-primary-600': on, 'bg-gray-200': ! on }"
        ></span>
        <span aria-hidden="true"
              class="translate-x-0 absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform group-focus:shadow-outline group-focus:border-blue-300 transition-transform ease-in-out duration-200"
              :class="{ 'translate-x-5': on, 'translate-x-0': ! on }"
        ></span>
    </span>
</template>

<script>
	export default {
	    model: {
	        prop: 'on',
            event: 'toggle',
        },

        props: {
            on: {
                type: Boolean,
                required: true,
            }
        }
	}
</script>
